import { openStudioTarget } from '../studio/studio-navigation';
interface VideoResultEntry {
  owner: number;
  orderId: number;
  revision: number;
  index: number;
  file: File;
  speech: 'original' | 'text';
  appId: number;
  format: string;
  createdAt: number;
}
let entry: VideoResultEntry | null = null;
/** Передаём свой файл только в памяти вкладки. Импорт требует нового подтверждения прав. */
export function stageVideoResult(value: Omit<VideoResultEntry, 'createdAt'>) {
  entry = { ...value, createdAt: Date.now() };
  openStudioTarget({ appId: value.appId, options: { source: 'video', format: value.format } });
}
export function readVideoResult() {
  if (entry && Date.now() - entry.createdAt > 1200000) entry = null;
  return entry;
}
export function clearVideoResult(expected: VideoResultEntry) {
  if (expected === entry) entry = null;
}
